// Module
var code = `<a aria-label="{{richDropdown.item.selectedTitle}}">{{richDropdown.item.selectedTitle}} <em ng-if="richDropdown.item.expired" translate="course-editor_expired-license"></em></a>`;
// Exports
export default code;